module.exports = __webpack_public_path__ + "img/location-b.030e4f49.svg";